import L from 'leaflet'

import { useRegionContext } from '@/pages/maps/contexts/region-context'

export function useFieldCentralization() {
  const { regionData, setCurrentViewBounds } = useRegionContext()

  return (fieldId: string) => {
    if (!regionData?.geojson?.features) return

    const feature = regionData.geojson.features.find(
      (f) => f.properties.id === fieldId,
    )

    if (feature) {
      const bounds = L.geoJSON(feature).getBounds()
      setCurrentViewBounds(bounds)
    }
  }
}
